<div fxLayout="row" fxLayoutAlign="space-between center" class="row col-12 container header-parent-div">
  <div class="logo-details col-4 col-md-5 col-xxl-4 col-sm-8 leftCustomWidth-xxxl" style="padding: 0px" fxLayout="row"
    fxLayoutAlign="start center">
    <a [routerLink]="'home'" class="logo" (click)="userTrack()">
      <img [src]="newLogo" alt="logo" class="logo-image" />
    </a>
    <div class="logo-divider"></div>
    <div class="greeting-message">
      {{ greetingMessage }}, <span class="employeNameYellow">{{ accountData?.profile?.employeeName }}</span>
    </div>
  </div>

  <div class="col-8 col-md-7 col-xxl-8 col-sm-4 rightCustomWidth-xxxl" fxLayout="row" fxLayoutAlign="end center"
    style="padding: 0px; position: initial;">
    <ng-container *ngIf="showSearchInput">
      <div class="search-input" fxLayout="row" fxLayoutAlign="start center">
        <div class="search-icon">
          <img src="assets/icons/search.png" alt="img" />
        </div>
        <input [formControl]="inputFormControl" #searchInput nbInput type="text" placeholder="Type to Search"
           style="padding-left: 2.5rem; padding-right: 2.5rem; max-width: 100%" />
        <div class="clear-search" (click)="handleSearchInput()">
          <img src="assets/icons/clear.png" alt="img" />
        </div>
        <div class="search-results-dropdown" #searchDropdown *ngIf="searchGroups?.length > 0 && showSearchTab"
          [attr.data-key]="activeTabIndex + '-' + searchGroups?.length">
          <nb-tabset [selectedIndex]="activeTabIndex" [attr.data-key]="tabRenderKey">
            <nb-tab *ngFor="let group of searchGroups; trackBy: trackByGroupName" [tabTitle]="group.name">
              <ng-container *ngIf="group.children.length > 0; else noResults">
                <nb-list>
                  <nb-list-item *ngFor="let option of group.children" (click)="getPeopleDetails(option, group.name)"
                    style="cursor: pointer">
                    <div class="people" *ngIf="group.name === 'People'">
                      <div>
                        <div class="name-icon">{{getInitials(option.displayName)}}</div>
                      </div>
                      <div>
                        <div class="name">{{ option.displayName }}</div>
                        <div class="role">{{ option.mail }}</div>
                      </div>
                    </div>
                    <div class="apps" *ngIf="group.name === 'Apps'">
                      <img [src]="getAppIcon(option.app_group)" alt="img" />
                      <div class="name">{{ option.app_name }}</div>
                    </div>
                  </nb-list-item>
                </nb-list>
              </ng-container>
              <ng-template #noResults>
                <div style="padding: 0.5rem; color: #999">
                  No search result found for {{ group.name }}
                </div>
              </ng-template>
            </nb-tab>
          </nb-tabset>
        </div>


      </div>
    </ng-container>
    <ng-container *ngIf="!showSearchInput">
      <div class="web">
        <ng-container *ngTemplateOutlet="menuTemplate"> </ng-container>
      </div>

      <div class="search" (click)="toggleSearchOpen($event)" #searchIcon>
        <img src="assets/icons/search-new.png" alt="img" />
      </div>

      <div class="notification" (click)="toggleSidenav('req-for-approval')" [ngClass]="
          selectedMenuOption == 'req-for-approval' ? 'selected-menu' : ''
        ">
        <div class="red-dot"
          *ngIf="attendanceReqForApprovalsData?.length || leaveRequestAvailableInDate || carReqForApprovalsData?.length || accommodationReqForApprovalsData?.length  || reminders?.length || synergyReqForApprovalsData?.tickets?.length || forexReqForApprovalsData?.length || hasActiveTownhall || hasActiveQuiz">
        </div>
        <img src="assets/icons/Notifications-new.png" alt="img" />
      </div>
      <div class="profile-details">
        <div>
          <nb-actions size="small">
            <nb-action class="user-action">
              <div class="userprofile" (click)="userprofile(); collapseSidenav()" [nbPopover]="popoverContent"
                nbPopoverPlacement="bottom" nbPopoverMode="click">

                <img [src]="getProfileImageSrc(profileData?.profileImage)" class="profileimage" alt="img" />
              </div>

              <span *ngIf="!showCancelLogo" class="menu-logo" (click)="toggleSidenav('menu')" style="margin: 0px 8px"
                [ngClass]="selectedMenuOption == 'menu' ? 'selected-menu' : ''">
                <img src="assets/icons/mobile-menu.png" alt="dropodown" width="37" />
              </span>
              <span *ngIf="showCancelLogo" class="cancel-logo" (click)="closeMenu()">
                <img [src]="cancelLogo" alt="cancel" />
              </span>

              <ng-template #popoverContent>
                <ltts-profile *ngIf="profileData" (closeMenuEvent)="handleChildEvent($event)"
                  [profileData]="profileData"></ltts-profile>
              </ng-template>

              <div *ngIf="showCancelLogo" class="custom-menu">
                <nb-card class="menucard">
                  <nb-card-body>
                    <nav class="navdetails">
                      <a nbButton [routerLink]="'home'" routerLinkActive="activelink" (click)="closeMenu()">Home</a>
                      <a nbButton [routerLink]="'my-team'" routerLinkActive="activelink" (click)="closeMenu()">My
                        Teams</a>
                      <a nbButton [routerLink]="'applications'" routerLinkActive="activelink"
                        (click)="closeMenu()">Applications</a>
                      <a nbButton (click)="navigateTo('feed')" routerLinkActive="activelink"
                        (click)="closeMenu()">Feed</a>

                      <a nbButton href="http://lttsopenaichatgpthr.azurewebsites.net/" target="_blank" rel="noopener"
                        routerLinkActive="activelink" (click)="closeMenu()">Genie</a>
                    </nav>
                    <div class="userImage" (click)="
                        closeMenu(); navigateById(profileData?.employeeId)
                      ">
                      <img [src]="getProfileImageSrc(profileData?.profileImage)" class="profilepic" alt="profilepic"
                        style="margin-right: 8px" />
                      <span style="padding-left: 12px">{{ username }}</span>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </nb-action>
          </nb-actions>
        </div>
      </div>
      <!-- section for new approval and reminders -->
      <nb-sidebar state="collapsed" tag="menu-sidebar" right fixed class="side-nav-sec" [ngClass]="selectedMenuOption"
        *ngIf="approval">
        <ng-container *ngIf="selectedMenuOption == 'menu'">
          <div class="mobile">
            <div class="menu-header" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="title">MENU</div>
              <div (click)="toggleSidenav()">
                <img src="assets/icons/menu-close.png" alt="img" />
              </div>
            </div>
            <ng-container *ngTemplateOutlet="menuTemplate"> </ng-container>
          </div>
        </ng-container>

        <div class="approvalSection">
          <ng-container *ngIf="selectedMenuOption == 'req-for-approval'">
            <div class="req-approval-section-header" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="title">My Approvals & Reminders</div>
              <div class="cursor" (click)="toggleSidenav()">
                <!-- <img src="assets/icons/closeicon.png" alt="img" /> -->
                <span><svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px"
                    fill="#FFF">
                    <path
                      d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                  </svg></span>
              </div>
            </div>

            <div class="notiication-combine-div-sec">
              <div style="height: auto; position: relative; overflow: hidden;">
                <ltts-request-for-approvals-v2 [approvalData]="reqForApprovalsData" [loadingData]="requestsDataLoading"
                  [attendanceApprovalData]="attendanceReqForApprovalsData"
                  [attendanceLoadingData]="attendanceRequestsDataLoading" (fetchAttendanceRequest)="
                  fetchRequestsForAttendanceApprovals(
                    this.accountData.profile.email
                  )
                " [leaveApprovalData]="leaveReqForApprovalsData" [leaveLoadingData]="leaveRequestsDataLoading"
                  (fetchLeaveRequest)="
                  fetchRequestsForLeaveApprovals(this.accountData.profile.employeeId)
                " [carApprovalData]="carReqForApprovalsData" [carLoadingData]="carRequestsDataLoading"
                  (fetchCarRequest)="
                  fetchRequestsForCarApprovals(this.accountData.profile.email)
                " [accommodationApprovalData]="accommodationReqForApprovalsData"
                  [accommodationLoadingData]="accommodationRequestsDataLoading" (fetchAccommodationRequest)="
                  fetchRequestsForAccommodationApprovals(
                    this.accountData.profile.email
                  )
                " (fetchRequest)="
                  fetchRequestForApprovalsData(this.accountData.profile.email)
                " [reminders]="reminders" [remindersLoading]="remindersLoading"
                  [forexReqForApprovalsData]="forexReqForApprovalsData"
                  [forexRequestsDataLoading]="forexRequestsDataLoading"
                  [synergyApprovalData]="synergyReqForApprovalsData" [synergyLoading]="synergyRequestsDataLoading"
                  (fetchSynergyRequest)="
                  fetchRequestsForSynergyApprovals(this.accountData.profile.email)" [hasActiveISMS]="hasActiveISMS"
                  [hasActiveDataPrivacy]="hasActiveDataPrivacy" [completedCount]="completedCount"
                  [notifications]="notifications || []" [hasActiveQuiz]="hasActiveQuiz"
                  [showQuizNotify]="showQuizNotify ?? true" [appraisalData]="appraisalData ?? true" [hasActiveTownhall]="hasActiveTownhall"
                  [showTownhallNotify]="showTownhallNotify ?? true" (collapseSidenavEvent)="cancelClicked()"
                  (navigateToUrlEvent)="navigateToUrl($event)">
                </ltts-request-for-approvals-v2>
              </div>


            </div>
            <!-- <div class="notiication-combine-div-sec">
              <div style="height: auto; position: relative; overflow: hidden;">
                <ltts-forex></ltts-forex>
              </div>
            </div> -->
            <div class="notiication-combine-div-sec">
              <div style="height: auto; position: relative; overflow: hidden;">
                <ltts-reminders-v2></ltts-reminders-v2>
              </div>
            </div>

            <div class="disclaimer-sec">

              <div class="buttonSection">
                <div fxLayout="row">
                  <button class="cancelBtn" (click)="cancelClicked()" nbButton size="small">Cancel</button>
                </div>
                <div fxLayout="row">
                  <button class="returnBtn" (click)="navigateToHome()" nbButton size="small">Return</button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

      </nb-sidebar>


      <nb-sidebar state="collapsed" tag="menu-sidebar" right fixed class="side-nav" [ngClass]="selectedMenuOption"
        *ngIf="!approval">
        <ng-container *ngIf="selectedMenuOption == 'menu'">
          <div class="mobile">
            <div class="menu-header" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="title">MENU</div>
              <div (click)="toggleSidenav()">
                <img src="assets/icons/menu-close.png" alt="img" />
              </div>
            </div>
            <ng-container *ngTemplateOutlet="menuTemplate"> </ng-container>
          </div>
        </ng-container>

        <div class="approvalSection">
          <ng-container *ngIf="selectedMenuOption == 'req-for-approval'">
            <div class="req-approval-section-header" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="title">Your approvals and reminders</div>
              <div class="cursor" (click)="toggleSidenav()">
                <img src="assets/icons/closeicon.png" alt="img" />
              </div>
            </div>
            <div class="notiication-combine-div">
              <div style="height: auto; position: relative; overflow: hidden;">
                <ltts-request-for-approvals [approvalData]="reqForApprovalsData" [loadingData]="requestsDataLoading"
                  [attendanceApprovalData]="attendanceReqForApprovalsData"
                  [attendanceLoadingData]="attendanceRequestsDataLoading" (fetchAttendanceRequest)="
                  fetchRequestsForAttendanceApprovals(
                    this.accountData.profile.email
                  )
                " [leaveApprovalData]="leaveReqForApprovalsData" [leaveLoadingData]="leaveRequestsDataLoading"
                  (fetchLeaveRequest)="
                  fetchRequestsForLeaveApprovals(this.accountData.profile.employeeId)
                " [carApprovalData]="carReqForApprovalsData" [carLoadingData]="carRequestsDataLoading"
                  (fetchCarRequest)="
                  fetchRequestsForCarApprovals(this.accountData.profile.email)
                " [accommodationApprovalData]="accommodationReqForApprovalsData"
                  [accommodationLoadingData]="accommodationRequestsDataLoading" (fetchAccommodationRequest)="
                  fetchRequestsForAccommodationApprovals(
                    this.accountData.profile.email
                  )
                " (fetchRequest)="
                  fetchRequestForApprovalsData(this.accountData.profile.email)
                " [reminders]="reminders" [remindersLoading]="remindersLoading"
                  [synergyApprovalData]="synergyReqForApprovalsData" [synergyLoading]="synergyRequestsDataLoading"
                  (fetchSynergyRequest)="
                  fetchRequestsForSynergyApprovals(this.accountData.profile.email)">
                </ltts-request-for-approvals>
              </div>
            </div>
            <div class="notiication-combine-div">
              <div style="height: auto; position: relative; overflow: hidden;">
                <ltts-reminders></ltts-reminders>
              </div>
            </div>

            <div class="disclaimer">
              <div class="reminder-text">
                <span style="color:#000000;font-weight:bold;font-size:15px">*Currently following reminders are
                  available.</span>
                <ol>
                  <li>Project Expiry</li>
                  <li>Visa Expiry</li>
                </ol>
              </div>
              <span style="color:#000000;font-weight:bold;font-size:15px">*Currently following approvals are
                avaiable.</span>
              <ol class="list-of-approvals">
                <li>Accommodation</li>
                <li>Attendance</li>
                <li>Cab</li>
                <li>Leave</li>
                <li>Synergy</li>
              </ol>
              <!-- <span>We have additional approvals in pipeline WIP.</span> -->
            </div>

          </ng-container>
        </div>

      </nb-sidebar>
    </ng-container>
  </div>

  <div class="overlay" [ngClass]="showOverlay ? 'show' : 'hidden'" (click)="toggleSidenav()"></div>

  <ng-template #menuTemplate>
    <div class="nav-details" role="navigation" (click)="collapseSidenav()">
      <a [routerLink]="'home'" (mouseover)="toggleClose()" (click)="headerClick('Home');" routerLinkActive="active-link">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names">
          <!-- <img [src]="currentUrl == '/home' ? 'assets/icons/home-active.png' : 'assets/icons/home.png'"> -->
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">Home</div>
        </div>
      </a>
      <a href="javascript:void(0);" style="position: relative;">
        <ul class="menu text-align-left" (click)="toggleAppsDropdown($event)">
          <li *ngFor="let item of appMenu; let i = index;" class="menu-item leftside"
            [ngClass]="{'has-children': item.children}" (mouseover)="toggleClose()">
            <div class="menu-names m-0" fxLayout="row" fxLayoutAlign="start center">
              <span class="menuicons">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
                  <path
                    d="M240-500v-220h220v220H240Zm0 260v-220h220v220H240Zm260-260v-220h220v220H500Zm0 260v-220h220v220H500ZM320-580h60v-60h-60v60Zm260 0h60v-60h-60v60ZM320-320h60v-60h-60v60Zm260 0h60v-60h-60v60ZM380-580Zm200 0Zm0 200Zm-200 0ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Z" />
                </svg>
              </span>
              <div class="name">{{ item.label }}</div>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                  fill="#1f1f1f">
                  <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
                </svg>
              </span>
            </div>
            <ul *ngIf="item.children" class="submenu appMenu container row flex-start">
              <li *ngFor="let child of item.children" class="menu-item rightside" routerLinkActive="active-link"
                [ngClass]="{'has-children': child.children}">
                <!-- {{child | json}} -->
                <div class="row m-0">
                  <div class="relative">
                    <div class="inner-child">
                      <div fxLayout="row" fxLayoutAlign="start center">
                        <img [src]="child?.item?.categoryIcon" alt="img">
                        {{ child?.item?.title}}
                      </div>
                      <span class="icon-show">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                          fill="#FFF">
                          <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- <div class="innerItemsDiv"> -->
                <ul *ngIf="child.children" class="submenu innerItem">
                  <!-- <li *ngFor="let subChild of child.children">
                    <a [href]="subChild?.app_url" target="_blank" rel="noopener" (click)="handleMyAppClick(subChild)"
                      routerLinkActive="active-link">
                      <img [src]="subChild?.app_group_icon" alt="img">
                      <span>{{ subChild?.app_name }}</span>
                    </a>
                  </li> -->
                  <li *ngFor="let subChild of child.children">
                    <!-- <li *ngIf="!(subChild?.app_name === 'TravelEx' && accountData?.profile?.email?.includes('_ext'))"> -->

                      <!--  Talent AI →Subchild logic -->
                      <a [nbTooltip]="subChild?.description" *ngIf="subChild?.app_name === 'Talent AI'; else checkPulse365" (click)="navigateToTalentAI()"
                        style="cursor: pointer;">
                        <img [src]="subChild?.app_group_icon" alt="img">
                        <span>{{ subChild?.app_name }}</span>
                      </a>

                      <!--  Pulse 365 Apps → Redirect to pulse365 -->
                      <ng-template #checkPulse365>
                        <a [nbTooltip]="subChild?.description" *ngIf="subChild?.app_name === 'Pulse365'; else externalLink" 
                          [routerLink]="'/pulse365'" (click)="handleMyAppClick(subChild)"
                          style="cursor: pointer;">
                          <img [src]="subChild?.app_group_icon" alt="img">
                          <span>{{ subChild?.app_name }}</span>
                        </a>
                      </ng-template>

                      <!--  Other Apps → External Links Keeping asusal-->
                      <ng-template #externalLink>
                        <a [nbTooltip]="subChild?.description" [href]="subChild?.app_url" target="_blank" rel="noopener" (click)="handleMyAppClick(subChild)"
                          routerLinkActive="active-link">
                          <img [src]="subChild?.app_group_icon" alt="img">
                          <span>{{ subChild?.app_name }}</span>
                        </a>
                      </ng-template>

                    </li>
                  <!-- </ng-container> -->



                </ul>
                <!-- </div> -->
              </li>
            </ul>
          </li>
        </ul>
      </a>

      <a [routerLink]="my-team-v2? 'my-team':'my-team-v2'" (mouseover)="toggleClose()" (click)="headerClick('My Teams');"
        routerLinkActive="active-link">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names">
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
                fill="white" />
              <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                fill="white" />
              <path
                d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                fill="white" />
              <path
                d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">My Teams</div>
        </div>
      </a>

      <div class="moredropdown">
        <a href="javascript:void(0);" class="header-name" (click)="showRemainingHeader() && headerClick('more')">
          <div fxLayout="row" fxLayoutAlign="start center" class="menu-names">
            <div class="name">More</div>
            <svg _ngcontent-aei-c82="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
              width="24px" fill="#1f1f1f" class="ng-tns-c82-235">
              <path _ngcontent-aei-c82="" d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"
                class="ng-tns-c82-235"></path>
            </svg>
          </div>
        </a>

        <div class="toggleOverlay" (click)="toggleClose()" *ngIf="showMoreHeader"></div>
        <div class="showMore" *ngIf="showMoreHeader">
          <a (click)="redirectBOD('board-of-directors')"
            routerLinkActive="active-link">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path
                  d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
              </svg>
              <div class="name">Board of Directors</div>
            </div>
          </a>

          <a *ngIf="kyl_access"
            (click)="navigateToUrl('/knowyourleader'); toggleClose(); headerClick('Connect-your-leader')">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path
                  d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
              </svg>
              <div class="name">Connect Your Leader</div>
            </div>
          </a>

          <a *ngIf="showCms && hasCmsAccess" [routerLink]="'content-upload'" (click)="navigateToCMS()">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path
                  d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
              </svg>
              <div class="name">CMS</div>
            </div>
          </a>

          

          <a href="javascript:void(0);" style="padding: 0; margin: 5px 0 0 0;">
            <ul class="menu" *ngIf="boardofdirectors" (click)="toggleAppsDropdown($event)" style="position: relative;">
              <li *ngFor="let item of departments" class="menu-item departments"
                [ngClass]="{'has-children': item.children}">
                <div class="menu-names" fxLayout="row" fxLayoutAlign="start center">
                  <div>
                    <span class="menuicons">
                      <svg width="20" height="18" viewBox="0 0 20 18" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z"
                          fill="white" fill-opacity="0.54" />
                      </svg>
                    </span>
                    <div class="name" [routerLink]="item?.url">{{ item.label }}</div>
                  </div>
                  <span *ngIf="item.children">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                      fill="#1f1f1f">
                      <path d="M584-480 344-240l-56-56 184-184-184-184 56-56 240 240Z" />
                    </svg>

                  </span>
                </div>
                <ul *ngIf="item.children" class="submenu departments-head container row inlineFlex"
                  style="width: 100%; right: auto; left:100%; top:0; justify-content: flex-start;">
                  <li *ngFor="let child of item.children; let i = index" class="menu-item departments-child"
                    (click)="navigateDepartment((i+1)+'-id', child.label)" routerLinkActive="active-link"
                    [ngClass]="{'has-children': child.children}">
                    <div class="row m-0">
                      <div class="relative">
                        <div class="inner-child" style="display: inline-flex;">
                          <div fxLayout="row" fxLayoutAlign="start center">
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                              fill="#FFF">
                              <path
                                d="M96-192v-92q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432q66 0 126.5 17T625-366q22 13 34.5 34.61T672-284v92H96Zm648 0v-92q0-42-19.5-78T672-421q39 8 75.5 21.5T817-366q22 13 34.5 34.67Q864-309.65 864-284v92H744ZM384-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm336-144q0 60-42 102t-102 42q-8 0-15-.5t-15-2.5q25-29 39.5-64.5T600-624q0-41-14.5-76.5T546-765q8-2 15-2.5t15-.5q60 0 102 42t42 102ZM168-264h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14t-99 42q-4.95 2.83-7.98 7.91-3.02 5.09-3.02 12V-264Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21ZM384-264Zm0-360Z" />
                            </svg>
                            {{ child.label }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul *ngIf="child.children" class="submenu innerItem">
                      <li *ngFor="let subChild of child.children" [routerLink]="'{{subChild.url}}'"
                        routerLinkActive="active-link">{{ subChild.label }}</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </a>
          <!-- <a (click)="toggleClose(); headerClick('Holiday')" href="https://lnttsgroup.sharepoint.com/sites/LTTS_Rainbow/SitePages/HolidayCalendarIndia.aspx" target="_blank"
            routerLinkActive="active-link">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <img src="/assets/icons/quiz.png" alt="icon" style="width: 18px;">
              <div class="name">Holiday Calendar</div>
            </div>
          </a>  -->
          <a *ngIf="quiz_access" (click)="navigateToUrl('/quiz'); toggleClose(); headerClick('quiz')"
            routerLinkActive="active-link">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <img src="/assets/icons/quiz.png" alt="icon" style="width: 18px;">
              <div class="name">InQuizitive</div>
            </div>
          </a>
          <a *ngIf="mood_analytics" [routerLink]="'mood-Graph'"
            (click)="toggleClose() && headerClick('GENIE')" routerLinkActive="active-link">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
                <path d="M160-200v-360h80v360h-80Zm560 0v-560h80v560h-80Zm-280 0v-200h80v200h-80Z" />
              </svg>

              <div class="name">Mood Analytics</div>
            </div>
          </a>
          <a [routerLink]="'declaration'" (click)="toggleClose(); headerClick('Declaration')">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path d="M319-250h322v-60H319v60Zm0-170h322v-60H319v60ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336l224 224v516q0 24-18 42t-42 18H220Zm0-60h520v-474L534-820H220v680Zm0 0v-680 680Z"/>
              </svg>
              <div class="name">Relationship Disclosure</div>
            </div>
          </a>
          <a [routerLink]="'townhall'" (click)="navigateToTownhall()"
            routerLinkActive="active-link">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path
                  d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
              </svg>
              <div class="name">Townhall</div>
            </div>
          </a>

        </div>
      </div>
      <a routerLinkActive="active-link" class="mobile-display"
        (click)="redirectBOD('Board of Directors')">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
                fill="white" />
              <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                fill="white" />
              <path
                d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                fill="white" />
              <path
                d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">Board of Directors</div>
        </div>
      </a>
      <a *ngIf="kyl_access" routerLinkActive="active-link" class="mobile-display"
        (click)="navigateToUrl('/knowyourleader');headerClick('Connect-your-leader')">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
                fill="white" />
              <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                fill="white" />
              <path
                d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                fill="white" />
              <path
                d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">Connect Your Leader</div>
        </div>
      </a>
      <a href="javascript:void(0);" style="padding: 0; margin: 5px 0 0 0;" class="mobile-display">
        <ul class="menu" *ngIf="boardofdirectors" (click)="toggleAppsDropdown($event)" style="position: relative;">
          <li *ngFor="let item of departments" class="menu-item departments"
            [ngClass]="{'has-children': item.children}">
            <div class="menu-names" fxLayout="row" fxLayoutAlign="start center">
              <div>
                <span class="menuicons">
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z"
                      fill="white" fill-opacity="0.54" />
                  </svg>
                </span>
                <div class="name" [routerLink]="item?.url">{{ item.label }}</div>
              </div>
              <span *ngIf="item.children">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                  fill="#1f1f1f">
                  <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
                </svg>
              </span>
            </div>
            <ul *ngIf="item.children" class="submenu departments-head container row inlineFlex department-Mobile"
              style=" right: auto; left: 0; justify-content: flex-start;">
              <li *ngFor="let child of item.children; let i = index" class="menu-item departments-child"
                (click)="navigateDepartment((i+1)+'-id', child.label)" routerLinkActive="active-link"
                [ngClass]="{'has-children': child.children}">
                <div class="row m-0">
                  <div class="relative">
                    <div class="inner-child" style="display: inline-flex;">
                      <div fxLayout="row" fxLayoutAlign="start center">
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                          fill="#FFF">
                          <path
                            d="M96-192v-92q0-25.78 12.5-47.39T143-366q54-32 114.5-49T384-432q66 0 126.5 17T625-366q22 13 34.5 34.61T672-284v92H96Zm648 0v-92q0-42-19.5-78T672-421q39 8 75.5 21.5T817-366q22 13 34.5 34.67Q864-309.65 864-284v92H744ZM384-480q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 60-42 102t-102 42Zm336-144q0 60-42 102t-102 42q-8 0-15-.5t-15-2.5q25-29 39.5-64.5T600-624q0-41-14.5-76.5T546-765q8-2 15-2.5t15-.5q60 0 102 42t42 102ZM168-264h432v-20q0-6.47-3.03-11.76-3.02-5.3-7.97-8.24-47-27-99-41.5T384-360q-54 0-106 14t-99 42q-4.95 2.83-7.98 7.91-3.02 5.09-3.02 12V-264Zm216.21-288Q414-552 435-573.21t21-51Q456-654 434.79-675t-51-21Q354-696 333-674.79t-21 51Q312-594 333.21-573t51 21ZM384-264Zm0-360Z" />
                        </svg>
                        {{ child.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <ul *ngIf="child.children" class="submenu innerItem">
                  <li *ngFor="let subChild of child.children" [routerLink]="'{{subChild.url}}'"
                    routerLinkActive="active-link">{{ subChild.label }}</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </a>
      <!-- <a  class="mobile-display" href="https://lnttsgroup.sharepoint.com/sites/LTTS_Rainbow/SitePages/HolidayCalendarIndia.aspx" target="_blank"
        (click)="headerClick('quiz')">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <img src="/assets/icons/quiz.png" alt="icon" style="width: 24px;">
          </span>
          <div class="name">Holiday</div>
        </div>
      </a> -->
       <a *ngIf="showCms && hasCmsAccess" [routerLink]="'content-upload'" class="mobile-display" (click)="navigateToCMS(); toggleSidenav();">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path
                  d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z" />
              </svg>
              <div class="name">CMS</div>
            </div>
          </a>
           <a [routerLink]="'declaration'" class="mobile-display" (click)="toggleClose(); headerClick('Declaration')">
            <div fxLayout="row" fxLayoutAlign="start center" class="menu-names" style="gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="18px" fill="#FFF">
                <path d="M319-250h322v-60H319v60Zm0-170h322v-60H319v60ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336l224 224v516q0 24-18 42t-42 18H220Zm0-60h520v-474L534-820H220v680Zm0 0v-680 680Z"/>
              </svg>
              <div class="name">Relationship Disclosure</div>
            </div>
          </a>
      <a routerLinkActive="active-link" *ngIf="quiz_access" class="mobile-display"
        (click)="navigateToUrl('/quiz');headerClick('quiz')">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <img src="/assets/icons/quiz.png" alt="icon" style="width: 24px;">
          </span>
          <div class="name">InQuizitive</div>
        </div>
      </a>

      <a *ngIf="mood_analytics" [routerLink]="'mood-Analytics'" routerLinkActive="active-link" class="mobile-display"
        (click)="headerClick('Mood Analytics'); toggleSidenav();">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
                fill="white" />
              <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                fill="white" />
              <path
                d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                fill="white" />
              <path
                d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">Mood Analytics</div>
        </div>
      </a>

      <a routerLinkActive="townhall" [routerLink]="'townhall'" class="mobile-display" (click)="headerClick('townhall'); toggleSidenav();">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <span class="menuicons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
                fill="white" />
              <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
                fill="white" />
              <path
                d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
                fill="white" />
              <path
                d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
                fill="white" />
            </svg>
          </span>
          <div class="name">Townhall</div>
        </div>
      </a>
      <a href="javascript:void(0);" class="employeFeedBack" *ngIf="empFeedbackDiv" nbTooltip="Mood Pulse"
        nbTooltipPlacement="bottom" (mouseover)="toggleClose()" (click)="openEmpPulse()">
        <img src="assets/feedback-icons/pulse-mood.svg" alt="pulse-icon">
      </a>
      <a class="alina-link" (mouseover)="toggleClose()" href="https://myltts.ltts.com/LEINA/chat" (click)="headerClick('Leina')">
        <div fxLayout="row" fxLayoutAlign="start center" class="menu-names blink-me">
          <img src="/assets/images/smiley-new.png" alt="img" class="alina-img">
          <div class="name">{{LINANAME}}</div>
        </div>
      </a>
      <a (click)="navigateById(profileData?.employeeId)" routerLinkActive="active-link" class="my-profile-mobile">
        <div fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
          <img src="assets/icons/favourites-old.png" alt="img" />
          <div class="name">MY PROFILE</div>
        </div>
      </a>
    </div>
  </ng-template>

  <div *ngIf="showPopupWidgetPicker" class="popup-widget-overlay" (click)="closePopupWidgetPicker()">
    <section class="popup-widget-picker" role="dialog" aria-modal="true" aria-labelledby="popupWidgetTitle"
      tabindex="-1" (click)="$event.stopPropagation()" (keydown)="onQuickActionsKeydown($event)">
      <header class="popup-widget-picker-header">
        <span id="popupWidgetTitle">QUICK ACTIONS</span>
        <button #quickActionCloseButton type="button" class="popup-widget-close" aria-label="Close quick actions"
          (click)="closePopupWidgetPicker()">X</button>
      </header>
      <p class="popup-widget-greeting">Hi <span style="color: #102868;">{{ quickActionGreetingName }}</span> , What would you like to do?</p>
      <div class="popup-widget-list">
        <button type="button" class="popup-widget-card" [disabled]="declarationDone" (click)="openDeclarationWidget()">
          <span class="popup-widget-icon declaration-widget-icon">
            <nb-icon icon="file-text-outline" pack="eva"></nb-icon>
          </span>
          <strong>Declaration</strong>
          <small>{{ declarationDone ? 'Completed' : 'Workplace relationships' }}</small>
        </button>
        <button type="button" class="popup-widget-card" [disabled]="moodDone" (click)="openEmployeeMoodWidget()">
          <span class="popup-widget-icon mood-widget-icon">
            <nb-icon icon="smiling-face-outline" pack="eva"></nb-icon>
          </span>
          <strong>Employee Mood</strong>
          <small>{{ moodDone ? 'Completed' : 'Share how you feel today' }}</small>
        </button>
        <button type="button" class="popup-widget-card" [disabled]="quizTileDisabled" (click)="openQuizWidget()">
          <span class="popup-widget-icon quiz-widget-icon">
            <nb-icon icon="clipboard-outline" pack="eva"></nb-icon>
          </span>
          <strong>Quiz</strong>
          <small>{{ quizDone ? 'Completed' : 'Open InQuizitive' }}</small>
        </button>
      </div>
    </section>
  </div>

  <button #quickActionLauncher *ngIf="showQuickActionLauncher && !showPopupWidgetPicker" type="button" class="quick-action-reopen"
    (click)="openPopupWidgetPicker()" aria-label="Open Quick Actions">
    <nb-icon icon="flash-outline" pack="eva"></nb-icon>
  </button>

   <div *ngIf="empFeedbackDiv">
    <div class="overlayFeedback" [ngClass]="showFeedOverlay ? 'show' : 'hidden'" (click)="closeFeedback()"></div>
    <div class="feedbackDiv" *ngIf="showFeedbackCapture" [ngClass]="{ 'expanded': isExpanded }">
      <div class="content-div">
        <div class="feedback-Header">
          <span [innerHTML]="headingText" class="title-text"></span>
          <span class="close" (click)="closeFeedback()"><svg xmlns="http://www.w3.org/2000/svg" height="24px"
              viewBox="0 -960 960 960" width="24px" fill="#FFF">
              <path
                d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
            </svg></span>
        </div>
        <div class="feedback-body">
          <div class="feedback-text">
            <h3 [innerHTML]="innerHead"></h3>
          </div>
          <div class="feedback-images" [class.highlighted]="isConditionMet">
            <span *ngFor="let item of feedbackItems"
              [ngClass]="item.className + (activeClassName === item.className ? ' active' : '') + (disableMood ? ' disabled' : '')"
              (click)="!disableMood && handleSpanClick(item)" title="{{ item.title }}" class="{{item.className}}-mood">
              <img [src]="item.icon" alt="{{item.className}}-icon">
              <span class="selectedFeed">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFF">
                  <path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z" />
                </svg>
              </span>
              <span>{{ item.title }}</span>
            </span>
          </div>
          <label class="chips-label" *ngIf="showComment">Quick fill options</label>
          <div class="chips-wrap" *ngIf="showComment">

            <button type="button" class="chip" *ngFor="let chip of chips"
              [class.selected]="selectedChipLabel === chip.label" (click)="onChipClick(chip.label)"
              [attr.aria-pressed]="selectedChipLabel === chip.label" [title]="chip.label">
              {{ chip.label }}
            </button>
          </div>

          <!-- Comment block only visible after an emoji is selected -->
          <div class="comment-section" *ngIf="showComment">
            <label class="comment-label required" aria-required="true" for="commentBox">What made you feel
              this way today?</label>
            <textarea id="commentBox" class="comment-input" [(ngModel)]="commentText" placeholder="Add a comment"
              rows="4" maxlength="100" required [readonly]="!isCommentEditable"
              [class.readonly]="!isCommentEditable"></textarea>
            <div class="helper">Please check your response before you post</div>


          </div>

        </div>
        <div class="feedback-footer">
          <ng-container *ngIf="hideCLosBtn">
            <button class="btn moodSubmit-Btn" #myButton [disabled]="isSubmitDisabled()" (click)="submitMood()">
              <svg xmlns="http://www.w3.org/2000/svg" *ngIf="showLoader" height="24px" viewBox="0 -960 960 960"
                width="24px" fill="#FFF">
                <path
                  d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z" />
              </svg>
              <span style="margin-top: 5px;">Submit</span>
            </button>
          </ng-container>
          <button class="btn moodSubmit-Btn" *ngIf="!hideCLosBtn" (click)="closeFeedback()">Ok</button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="empQuizPopup ">
    <div class="overlayQuiz" [ngClass]="showQuizOverlay ? 'show' : 'hidden'" (click)="closeQuizPopup()"></div>
    <div class="quizDiv">
      <div class="content-div">
        <div class="quiz-Header">
          <span [innerHTML]="QuizTItleText" class="title-text"></span>
          <span class="close" (click)="closeQuizPopup()"><svg xmlns="http://www.w3.org/2000/svg" height="24px"
              viewBox="0 -960 960 960" width="24px" fill="#FFF">
              <path
                d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
            </svg></span>
        </div>
        <div class="quiz-body">
          <div class="quiz-text">
            <img src="./assets/images/Quiz-img.png" t="">
            <div class="textDiv">
              <div class="topText">
                <h3 [innerHTML]="QuizInnerHead"></h3>
                <p [innerHTML]="QuizInnerPara"></p>
              </div>
              <div class="bottomDiv">
                <div class="buttondiv">
                  <button class="btn reminderBtn" (click)="closeQuizPopup()">Later</button>
                  <button class="btn quizBtn" (click)="navigateToQuiz()">Proceed <svg class="mb-1 ml-2"
                      xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                      fill="#FFF">
                      <path d="m576-288-51-51 105-105H192v-72h438L525-621l51-51 192 192-192 192Z" />
                    </svg></button>
                </div>
                <p>You can also attempt it later from the InQuizitive option in the home page menu.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="talentAIPopup && talentAIData">
    <div class="overlayQuiz" [ngClass]="showTalentOverlay ? 'show' : 'hidden'"></div>
    <div class="talentDiv">
      <div class="content-div">
        <div class="quiz-Header">

          <div class="logo">
            <img src="/assets/images/Talent.png" alt="Talent AI" />
            <span class="title-text">Talent AI</span>
          </div>
        </div>
        <div class="quiz-body">
          <div class="quiz-text">
            <img src="./assets/images/bulb.png" t="">
            <div class="textDiv">
              <h2>Talent AI is Now Live!</h2>
              <p class="description">
                Update your skills and experience the magic of AI-powered
                talent matching. Let our intelligent system unlock new
                opportunities tailored just for you.
              </p>
              <div class="info-pill">
                Takes less than 5 minutes to complete
              </div>
              <div class="actions">
                <!-- <button class="btn secondary" (click)="closeTalentPopup()">Remind Me Later</button> -->
                <button class="btn primary" (click)="navigateToTalentAI()">
                  Update Skills Now →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #searchTemplate>
      <div class="col-xxxl-12 col-xxl-12 col-lg-12 col-md-12" fxLayout="column" fxLayoutAlign="end end"></div>
      <div class="global-search-container">
        <div class="search-container form-wrapper col-xxxl-12 col-xxl-12 col-lg-12 col-md-12">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="search-bar-container form-content col-11">
              <input placeholder="Search People" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                class="form-control search search-input" [formControl]="searchControl" />
              <button class="clear-search" *ngIf="searchControl.value && searchControl.value.trim()" nbButton
                (click)="cancel()">
                Clear Search
              </button>
            </div>
            <div fxLayout="column" fxLayoutAlign="center center" style="padding: 10px" class="col-1">
              <button nbbutton=""
                class="close-button appearance-ghost size-medium shape-rectangle icon-start icon-end status-basic nb-transition"
                aria-disabled="false" tabindex="0">
                <nb-icon (click)="isShowing = false" class="close-icon" icon="close-outline" pack="nebular-essentials">
                </nb-icon>
              </button>
            </div>
          </div>
          <div class="search-results scrollable-container" *ngIf="showSearchResults"
            [ngStyle]="{ 'max-height': maxHeight }">
            <ul *ngIf="searchData?.length">
              <li *ngFor="let result of searchData" (click)="onResultClick(result)">
                {{ result.displayName }}
              </li>
            </ul>
          </div>

          <div *ngIf="selectedResult" class="selected-result">
            <div class="profile-name" fxLayout="row" fxLayoutAlign="start center" style="padding: 0.5rem 5rem">
              <img [src]="getProfileImageSrc(profileImage)" alt="img" />
              <div style="padding-left: 35px">
                <b>{{ selectedResult.displayName }}</b>
              </div>
            </div>
            <div style="padding: 0.5rem 5rem" fxLayout="row" fxLayoutAlign="start center">
              <div class="mail contact-details" fxLayout="row" fxLayoutAlign="start center">
                <img [src]="envelope" alt="img" />
                <span class="profile-card-content" style="padding-left: 1rem">{{
                  selectedResult.mail ? selectedResult.mail : "--"
                  }}</span>
              </div>

              <div class="mobile-number contact-details" fxLayout="row" fxLayoutAlign="start center">
                <img [src]="Telephone" alt="img" />
                <span class="profile-card-content" style="padding-left: 1rem">{{
                  selectedResult.mobile ? selectedResult.mobile : "--"
                  }}</span>
              </div>

              <div class="office-location contact-details" fxLayout="row" fxLayoutAlign="start center">
                <img [src]="locality" alt="img" />
                <span class="profile-card-content" style="padding-left: 1rem">{{
                  selectedResult.officeLocation
                  ? selectedResult.officeLocation
                  : "--"
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div></div>
    </ng-template>
  </div>

<div *ngIf="showPopup">
  <div class="appraisal-overlay" [ngClass]="showAppraisalOverlay ? 'show' : 'hidden'" (click)="closeAppraisalPopup()">
  </div>
  <div class="appraisal-popup">
    <!-- HEADER -->
    <div class="popup-header">
      <div class="badge">
        <img src="assets/icons/kaleidoscope-logo.png" alt="Kaleidoscope Logo" />
      </div>
      <span class="close" (click)="closePopup()">✕</span>
    </div>
    <!-- BODY -->
    <div class="popup-body">
      <!-- ICON -->
      <div class="icon-wrapper">
        <div class="circle">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <rect x="6" y="4" width="12" height="16" rx="2" stroke="white" stroke-width="2" />
            <path d="M9 2H15" stroke="white" stroke-width="2" />
            <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" />
          </svg>
          <span class="tick">✔</span>
        </div>
      </div>
      <!-- TITLE -->
      <h2>Access Temporarily Restricted</h2>
      <!-- DESCRIPTION -->
      <p class="desc">
       Your Outlook and Teams access has been temporarily restricted due to pending self assessment/IS reviews. Please complete these required appraisal activities to restore access.
      </p>
      
      
      <!-- ACTIONS -->
      <div class="actions">
        <button class="secondary" (click)="openITM()">Need help?</button>
        <button class="primary" (click)="openKaleidoscope()">
          Complete My Review →
        </button>
      </div>
    </div>
  </div>
</div>



  <style>
    /* Container for the box and its pseudo-element border */
    .alina-link {
      position: relative;
      overflow: hidden;
      padding: 3px !important;
      /* The width of the border */
      border-radius: 30px;
      /* For rounded corners */
      z-index: 1;
    }

    /* The element that is the content of the box */
    /* .box-content {
    padding: 1rem;
    background: #111;
    Inner background color
    color: #fff;
    border-radius: 8px;
  } */

    .alina-link .menu-names {
      display: flex;
      align-items: center;
      gap: 8px;
      border: 3px solid transparent;
      background-color: #102868;
      padding: 0px 10px;
      border-radius: 30px;
    }

    .alina-link .menu-names .name {
      padding: 0;
    }

    /* The pseudo-element that creates the moving gradient border */
    .alina-link::before {
      content: '';
      position: absolute;
      top: -200%;
      left: -200%;
      width: 400%;
      height: 400%;
      background: conic-gradient(from var(--angle),
          #38E0BD,
          #3797BD,
          #5564A0,
          #7848CF);
      animation: rotate 2s linear infinite;
      z-index: -1;
      /* background-color: linear-gradient(90deg, #38E0BD 0%, #3797BD 30.11%, #5564A0 63.91%, #7848CF 100%); */
    }

    /* Define the custom property for smooth animation (@property is modern CSS) */
    @property --angle {
      syntax: '<angle>';
      initial-value: 0deg;
      inherits: false;
    }

    /* The animation keyframes */
    @keyframes rotate {
      to {
        --angle: 360deg;
      }
    }
  </style>